import "core-js/modules/es.array.push.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-70adf1c6"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/favicon.png",
  alt: "logo",
  class: "title-logo"
}, null, -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "ml16 ft18 boldFont"
}, "速记星超常儿童智力甄别和训练系统", -1));
const _hoisted_3 = {
  class: "count-down"
};
const _hoisted_4 = {
  style: {
    "width": "80%",
    "margin": "auto"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "negotiate-title"
}, "中科超常儿童自我体验甄别诚信承诺书", -1));
const _hoisted_6 = {
  class: "negotiate-title-No"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "negotiate-title-tips"
}, "请仔细阅读题目说明及观看作答演示后点击【进入考试】", -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "优秀学生的重要品质是诚实守信和认识自我，家长要对孩子负责，做孩子诚信的榜样，为保证本次题别结果的公平与公正，请学生和家长以诚信为本，遵守下列规则:", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "1.认真对待甄别中的每一道题，按要求在规定时间内登录系统，完成作答。", -1));
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "2.甄别过程是利用电脑在线完成，不需要纸笔、计算器等其他辅助工具，答题过程中请勿打开其他软件。", -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "3.甄别必须由报名学生本人独立完成，作答时不得讨论、抄袭，不得由他人协助或代替作答。", -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "4.甄别过程包含作弊监测，系统将全程录像和录音，并分析学生作答模式，判断作答是否存在不诚信行为。", -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "5.本次甄别并不是最终选拔,后续还包含其他甄别环节。如确定学生在自我体验甄别过程中出现过不诚信行为,后果自负。", -1));
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "·学生承诺:我承诺在甄别过程中诚信律己，遵守甄别规则。", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "·家长承诺:我承诺在甄别过程中诚信律己，为孩子提供良好的甄别环境，与孩子共同遵守甄别规则。", -1));
const _hoisted_16 = {
  style: {
    "width": "80%",
    "margin": "auto"
  }
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h1", {
  class: "negotiate-title"
}, "中科超常儿童自我体验甄别诚信承诺书", -1));
const _hoisted_18 = {
  class: "negotiate-title-No"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "negotiate-title-tips"
}, "请仔细阅读题目说明及观看作答演示后点击【进入考试】", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "- 本次甄别作答在电脑上完成，使用鼠标作答，不允许使用纸笔等其他任何辅助工具作答。", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "- 在甄别过程中保持注意力高度集中，先认真观看视频，严格按照视频讲解的方法、规则和要求进行别，否则会影响你的甄别结果，甚至终止甄别。", -1));
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "- 每个单元均有独立的答题时间限制，答题页面上会显示当前单元剩余时间，请注意控制答题进度。每个单元的答题时长情况如下:", -1));
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "- 观看单元说明视频不占用答题时间，但是会占用系统开放时长，系统从甄别时间开始会在规定总时间内关闭，未答题完毕的学生将无法继续作答。", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "- 每个单元的答题时长是独立的，当单元内答题时长用完后，会自动进入下一单元的说明页面或结束甄别。", -1));
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "- 在甄别过程中，答题单元内请按照题目顺序依次作答，且进入“下一题”后无法修改上一题答案，进入下一单元后，也无法返回上一单元进行修改。", -1));
const _hoisted_26 = {
  key: 1,
  class: "unit-desc"
};
const _hoisted_27 = {
  key: 0,
  style: {
    "width": "1278px",
    "text-align": "left",
    "margin": "auto"
  }
};
const _hoisted_28 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "题目说明：", -1));
const _hoisted_29 = {
  id: "myVideo",
  width: "640",
  height: "480",
  controls: "",
  style: {
    "margin": "auto"
  }
};
const _hoisted_30 = ["src"];
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "·学生承诺:我承诺在甄别过程中诚信律己，遵守甄别规则。", -1));
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "·家长承诺:我承诺在甄别过程中诚信律己，为孩子提供良好的甄别环境，与孩子共同遵守甄别规则。", -1));
const _hoisted_33 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_WatermarkerView = _resolveComponent("WatermarkerView");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_tabs = _resolveComponent("el-tabs");
  const _component_el_button = _resolveComponent("el-button");
  const _component_DigitSymbolReactionSession = _resolveComponent("DigitSymbolReactionSession");
  const _component_MockExamAnswerCard = _resolveComponent("MockExamAnswerCard");
  const _component_el_col = _resolveComponent("el-col");
  const _component_MockExamQuestionRenderPage = _resolveComponent("MockExamQuestionRenderPage");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_WatermarkerView), _createElementVNode("div", {
    class: "TrainAnswerViewContainer",
    style: _normalizeStyle($data.examing ? {
      'background-color': $data.subject === 'DigitSymbolReaction' ? '#edf4fb' : '#015EF5'
    } : {})
  }, [_createVNode(_component_el_row, {
    class: "wd100 wbg flex items-center opd20 ptr header",
    style: {
      "height": "60px",
      "width": "100%"
    },
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/'))
  }, {
    default: _withCtx(() => [_hoisted_1, _hoisted_2, _createElementVNode("div", _hoisted_3, "距离" + _toDisplayString(this.paperType === 'RETAKE' ? '复试' : '初试') + "甄别结束剩余时间: " + _toDisplayString($data.mockExamLeftTime), 1)]),
    _: 1
  }), !$data.examing && $data.unitOrder === 1 && !$data.loading ? (_openBlock(), _createBlock(_component_el_row, {
    key: 0
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tabs, {
      modelValue: $data.activeName,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.activeName = $event),
      class: "negotiate-tabs"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
        label: "诚信协议",
        name: "first"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", _hoisted_6, "编号：" + _toDisplayString($data.No) + " " + _toDisplayString(this.paperType === 'RETAKE' ? '复试' : '初试'), 1), _hoisted_7, _hoisted_8, _hoisted_9, _hoisted_10, _hoisted_11, _hoisted_12, _hoisted_13, _hoisted_14, _hoisted_15])]),
        _: 1
      }), _createVNode(_component_el_tab_pane, {
        label: "甄别须知",
        name: "second"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, "编号：" + _toDisplayString($data.No) + " " + _toDisplayString(this.paperType === 'RETAKE' ? '复试' : '初试'), 1), _hoisted_19, _hoisted_20, _hoisted_21, _hoisted_22, _createVNode(_component_el_table, {
          data: $data.paperType === 'INITIAL' ? $data.tableData1 : $data.tableData2,
          style: {
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_table_column, {
            prop: "unit1",
            label: "第一单元"
          }), _createVNode(_component_el_table_column, {
            prop: "unit2",
            label: "第二单元"
          }), _createVNode(_component_el_table_column, {
            prop: "unit3",
            label: "第三单元"
          }), _createVNode(_component_el_table_column, {
            prop: "answer",
            label: "总答题时长"
          }), _createVNode(_component_el_table_column, {
            prop: "all",
            label: "总时长"
          })]),
          _: 1
        }, 8, ["data"]), _hoisted_23, _hoisted_24, _hoisted_25])]),
        _: 1
      })]),
      _: 1
    }, 8, ["modelValue"]), _createVNode(_component_el_button, {
      style: {
        "margin": "auto"
      },
      type: "primary",
      onClick: $options.goToUnit
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.activeName === 'first' ? '下一页' : '我阅读了解并遵守诚信协议和甄别须知, 进入考试'), 1)]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  })) : _createCommentVNode("", true), $data.loading && $data.subject ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_el_row, {
    class: "negotiate-title",
    style: {
      "margin-top": "10px"
    }
  }, {
    default: _withCtx(() => [_createTextVNode("编号" + _toDisplayString($data.No) + "（正式 " + _toDisplayString(this.paperType === 'RETAKE' ? '复试' : '初试') + "）第 " + _toDisplayString($data.unitOrder) + " 单元说明 ", 1)]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "negotiate-title-tips"
  }, {
    default: _withCtx(() => [_createTextVNode("请仔细阅读题目说明及观看作答演示后点击【进入考试】")]),
    _: 1
  }), $options.subjectInfo.describe ? (_openBlock(), _createElementBlock("div", _hoisted_27, [_createVNode(_component_el_row, null, {
    default: _withCtx(() => [_hoisted_28, (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.subjectInfo.describe, d => {
      return _openBlock(), _createElementBlock("div", {
        key: d
      }, _toDisplayString(d), 1);
    }), 128))]),
    _: 1
  }), _createVNode(_component_el_row, null, {
    default: _withCtx(() => [_createElementVNode("video", _hoisted_29, [_createElementVNode("source", {
      src: $options.subjectInfo.link,
      type: "video/mp4"
    }, null, 8, _hoisted_30), _createTextVNode(" Your browser does not support the video tag. ")])]),
    _: 1
  })])) : (_openBlock(), _createBlock(_component_el_row, {
    key: 1,
    style: {
      "text-align": "left"
    }
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, "题目名称：" + _toDisplayString($options.subjectInfo.name), 1), _createElementVNode("div", null, "描述：" + _toDisplayString($options.subjectInfo.desc), 1), _createElementVNode("div", null, "考察方向：" + _toDisplayString($options.subjectInfo.tags.join(',')), 1), _createElementVNode("div", null, "历史考察记录：" + _toDisplayString($options.subjectInfo.hightlight), 1), _hoisted_31, _hoisted_32]),
    _: 1
  })), _createVNode(_component_el_button, {
    type: "primary",
    class: "unit-button",
    onClick: $options.goToExam,
    disabled: $data.buttonCountDown > 0
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString($data.buttonCountDown > 0 ? '倒计时（' + $data.buttonCountDown + '）秒后，可进入考试' : '进入考试'), 1)]),
    _: 1
  }, 8, ["onClick", "disabled"])])) : _createCommentVNode("", true), $data.examing && !$data.loading && $data.session && $data.subject === 'DigitSymbolReaction' ? (_openBlock(), _createBlock(_component_DigitSymbolReactionSession, {
    key: 2,
    session: $data.session,
    mode: "mock",
    onFinished: $options.nextUnit
  }, null, 8, ["session", "onFinished"])) : $data.examing && !$data.loading ? (_openBlock(), _createBlock(_component_el_row, {
    key: 3,
    class: "mt32",
    style: {
      "width": "1278px"
    }
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 4,
      style: {
        "display": "flex"
      }
    }, {
      default: _withCtx(() => [$data.session ? (_openBlock(), _createBlock(_component_MockExamAnswerCard, {
        key: 0,
        width: $options.ansModeMap() < 1 ? 4 : 0,
        onTimeup: $options.nextUnit,
        current: $data.current,
        "group-size": $options.ansTypeMap(),
        session: $data.session
      }, null, 8, ["width", "onTimeup", "current", "group-size", "session"])) : _createCommentVNode("", true)]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 20,
      class: "pdl10"
    }, {
      default: _withCtx(() => [$data.session ? (_openBlock(), _createBlock(_component_MockExamQuestionRenderPage, {
        key: 0,
        ref: "questionRender",
        onNext: _cache[2] || (_cache[2] = $event => $data.current += $options.ansTypeMap()),
        onNextUnit: $options.nextUnit,
        "group-size": $options.ansTypeMap(),
        subject: $data.subject,
        data: $data.session
      }, null, 8, ["onNextUnit", "group-size", "subject", "data"])) : _createCommentVNode("", true)]),
      _: 1
    })]),
    _: 1
  })) : _createCommentVNode("", true), _createVNode(_component_el_dialog, {
    modelValue: $data.endShow,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.endShow = $event),
    title: "甄别考试提示",
    width: "500"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_33, [_createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.goToExamList
    }, {
      default: _withCtx(() => [_createTextVNode(" 返回首页 ")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createElementVNode("span", null, "您的编号：" + _toDisplayString($data.No) + "甄别测试" + _toDisplayString(this.paperType === 'RETAKE' ? '复试' : '初试') + "已结束", 1)]),
    _: 1
  }, 8, ["modelValue"])], 4)], 64);
}